import styled, { ThemeProvider } from 'styled-components';
export var SVGThemeProvider = ThemeProvider;
export var SVGStyled = styled;